import { useEffect, PropsWithChildren } from "react";
import ReactGA from "react-ga";
import { useLocation } from "react-router";

interface WrapperProps {
    children: PropsWithChildren<any>;
}

export function Wrapper(props: WrapperProps) {
    const location = useLocation();

    useEffect(() => {
        ReactGA.pageview(location.pathname + location.search);
    }, [location]);

    return props.children
};
